declare const ENUM_STRINGS: String;

export function ev(stringValue, intValue) {

    return ENUM_STRINGS ? stringValue : intValue;
}